import { getGlobalThis } from '../../../ssr-window';
const storageKey = Symbol.for('client-sandbox-storage');
const globalThat = getGlobalThis();
/**
 * 创建 SandboxStorage 实例，并缓存到全局
 * @returns
 */
const getSandboxStorage = () => {
    var _a;
    // eslint-disable-next-line no-multi-assign
    const sandboxStorage = ((_a = globalThat[storageKey]) !== null && _a !== void 0 ? _a : (globalThat[storageKey] = new Map()));
    return sandboxStorage;
};
export const sandboxStorageWrapper = {
    async run(store, callback) {
        const sandboxStorage = getSandboxStorage();
        // 初始值保存到 sandboxStorage 中
        Object.keys(store).forEach((key) => sandboxStorage.set(key, store[key]));
        const res = new Promise(async (reslove) => {
            const retult = await callback();
            reslove(retult);
        });
        return res;
    },
    getStore: (key) => {
        const sandboxStorage = getSandboxStorage();
        return sandboxStorage.get(key);
    },
};
/**
 * 获取状态存储对象
 * @returns
 */
export const getStore = (key) => sandboxStorageWrapper.getStore(key);
/**
 * 获取应用上下文
 */
// export const getAppCtx = () => {
//   return localStorageWrapper.getStore('context');
// };
/**
 * 获取RequestContext
 * @returns
 */
export const getReqCtx = () => sandboxStorageWrapper.getStore('ctx');
